@if (notification?.state === 'empty') {
<div class="no-notif-box">{{ emptyNotificationMessage | transloco }}</div>
} @else {
<div class="notif-box">
    <!-- [ngClass]="{'notif-box-opened' : notification.opened}" -->
    <div class="notif-box-inside">
        <div class="notif-content">
            <div class="notif-image" style="min-width: 40px;" fxLayout="row" fxLayoutAlign="center center">
                @if(identifyProfil(notification) != 'system') {
                    <app-user-icon 
                    [type]="'xs'" 
                    [img_url]="notification.image">
                    </app-user-icon>
                } @else {
                    <!-- <app-user-icon 
                    [type]="'xs'" 
                    [img_url]="'/assets/images/avatars/system.png'">
                    </app-user-icon> -->
                    <!-- <img src="/assets/images/avatars/system.png" alt="candidate Profil Image" class="notif-profil-image"> -->
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" height="35px" viewBox="0 -960 960 960" width="35px" fill="#e8eaed">
                        <path d="m382-80-18.67-126.67q-17-6.33-34.83-16.66-17.83-10.34-32.17-21.67L178-192.33 79.33-365l106.34-78.67q-1.67-8.33-2-18.16-.34-9.84-.34-18.17 0-8.33.34-18.17.33-9.83 2-18.16L79.33-595 178-767.67 296.33-715q14.34-11.33 32.34-21.67 18-10.33 34.66-16L382-880h196l18.67 126.67q17 6.33 35.16 16.33 18.17 10 31.84 22L782-767.67 880.67-595l-106.34 77.33q1.67 9 2 18.84.34 9.83.34 18.83 0 9-.34 18.5Q776-452 774-443l106.33 78-98.66 172.67-118-52.67q-14.34 11.33-32 22-17.67 10.67-35 16.33L578-80H382Zm55.33-66.67h85l14-110q32.34-8 60.84-24.5T649-321l103.67 44.33 39.66-70.66L701-415q4.33-16 6.67-32.17Q710-463.33 710-480q0-16.67-2-32.83-2-16.17-7-32.17l91.33-67.67-39.66-70.66L649-638.67q-22.67-25-50.83-41.83-28.17-16.83-61.84-22.83l-13.66-110h-85l-14 110q-33 7.33-61.5 23.83T311-639l-103.67-44.33-39.66 70.66L259-545.33Q254.67-529 252.33-513 250-497 250-480q0 16.67 2.33 32.67 2.34 16 6.67 32.33l-91.33 67.67 39.66 70.66L311-321.33q23.33 23.66 51.83 40.16 28.5 16.5 60.84 24.5l13.66 110Zm43.34-200q55.33 0 94.33-39T614-480q0-55.33-39-94.33t-94.33-39q-55.67 0-94.5 39-38.84 39-38.84 94.33t38.84 94.33q38.83 39 94.5 39ZM480-480Z"/>
                    </svg> -->
                    <mat-icon [svgIcon]="'mat_outline:settings'" [style.fill]="'#e8eaed'" style="width:30px; height:30px;"></mat-icon>
                }

              
                <!-- <img src="../../../../../assets/images/avatars/agent.png" alt="Profil Image" class="notif-profil-image"> -->
            </div>
            <div class="notif-content-inside">
                <div class="notification-title"  (click)="markasOpened(notification)">
                    <div class="notif-message" dir="auto">
                            <b><span [innerHTML]="notification.title"></span></b>&nbsp;
                            <span [innerHTML]="notification.message">
                            </span>
                    </div>
                    <div class="notif-date body-small">
                        {{getDate(notification)}}
                    </div>
                </div>
                <div class="notif-details" *ngIf="notification.body">
                    <div class="notif-details-inside"[ngClass]=" {
                        'notif-details-empty' : checkIfBodyEmpty(body)
                    }">
                        <ng-container *ngFor="let item of body | keyvalue">
                            <span *ngIf="item.value !== ''">
                                <b *ngIf="item.key !== 'single'">{{ item.key.charAt(0).toUpperCase() + item.key.slice(1) }} : </b>
                                <span [innerHTML]="item.value"></span>
                                <br>
                            </span>
                        </ng-container>

                        <div *ngIf="tagsToShow.length" class="notif-tag-section">

                            <ng-container *ngFor="let tag of tagsToShow">

                                <div class="notif-tag"
                                        [matTooltip]= "tag.matTooltip"
                                        [class]="tag.tagClass"
                                        [ngClass]="{
                                            'none': tag.label == 'Une réponse',
                                            'seance-code': tag.label == 'séance code',
                                            'seance-conduite': tag.label == 'séance conduite',
                                            'seance-resyclage': tag.label == 'séance recyclage',
                                            'exam-code': tag.label == 'examen code' || tag.label == 'Code',
                                            'exam-conduite': tag.label == 'examen conduite' || tag.label == 'Conduite',
                                            'exam-circulation': tag.label == 'examen circulation' || tag.label == 'Circulation',
                                            'exam-manoeuvre': tag.label == 'examen manoeuvre' || tag.label == 'Manoeuvre',
                                            'depence-tag': tag.type == 'famille'
                                        }"
                                        *ngIf="tag.label != 'label'"
                                    >
                                    {{tag.label}}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="notif-shortcut-buttons">
                    <div class="reply-box" *ngIf="buttonsToShow?.[0]?.buttonType === 'envoyer'">
                        <input
                            id="myInput"
                            type="text"
                            [value]="inputValue"
                            (input)="onInputChange($event)"
                            (click)="eventStop($event)"
                            placeholder="repondre..."
                        >
                    </div>
                    <button
                    (click)="eventStop($event)"
                    *ngFor="let button of buttonsToShow"
                    [ngClass]="button.buttonClass"
                    >
                        {{button.buttonType}}
                    </button>
                </div>

            </div>
        </div>
        <div class="notif-icon" (click)="markasOpened(notification,redirect=false)">
            <div *ngIf="!notification.opened" class="notif-dot">
            </div>
        </div>
    </div>
</div>
}
